<template>
 <div>
  <div class="container">
    <div style="width: 1200px; margin-top: 40px">
      <p class="title">
        【重磅发布】来自世界品牌论坛发起的认证，Tetra德彩三度荣膺德国“世纪品牌奖”
      </p>

      <p style="font-size: 20px; color: #333; line-height: 2em">
        摘要：2022年重磅消息，世界品牌论坛第三度授予Tetra德彩“世纪品牌奖”，以表彰Tetra德彩杰出的观赏鱼饲料产品。Tetra德彩再度获得桂冠，三度荣膺世界级别品牌奖项，实力展现全球水族领导品牌的地位！
        <br /><br />
        <span style="color: #2963a4; font-weight: 600; font-size: 20px">
          Tetra德彩三度荣膺德国“世纪品牌奖”
        </span>
        <br />
        2022年开端即传来喜讯，Tetra德彩连续三次获得德国「世纪品牌奖」，成为水族品牌当之无愧的引领者。
      </p>

      <div class="d-flex j-center" style="width: 1200px">
        <!-- 图片 -->
        <div style="width: 1100px; margin: 30px 0">
          <img
            src="../assets/article01.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>

      <p style="font-size: 20px; color: #333; line-height: 2em">
        “世纪品牌奖”由世界品牌论坛发起。作为一个非营利组织，它的任务是提高全球的品牌标准。自2014年以来，一直为各行业一流企业认证颁奖。
        <br />
        <span style="color: #333; font-weight: 600; font-size: 20px">
          今年，全球有1000多家 公司被提名。来自 41个国家的150个 品牌获得了奖项。获奖者是通过
          全球市场调查、品牌评价、公众投票等方式选出的。
        </span>
      </p>

      <div class="d-flex j-center" style="width: 1200px">
        <!-- 图片 -->
        <div style="width: 1100px; margin: 30px 0">
          <img
            src="../assets/article02.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>

      <p style="font-size: 20px; color: #333; line-height: 2em">
        <span>
          该奖项被誉为德国品牌的百科全书，由一个顶级品牌专家组成的顾问委员会进行评选，颁发给在行业内设定了示范性领头的企业，
          并由弗洛里安·朗根沙伊特博士（Florian Langenscheidt）
          与其团队每3年评选一次。目前约有200个品牌被收录其中，
          其他行业代表荣获该项奖项的德国公司还包括蔡司(Zeiss)、保时捷(Porsche)、汉莎航空公司(Lufthansa)等。
        </span>
      </p>

      <div class="d-flex j-center" style="width: 1200px">
        <!-- 图片 -->
        <div style="width: 1100px; margin: 30px 0">
          <img
            src="../assets/article03.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>

      <p style="font-size: 20px; color: #333; line-height: 2em">
        <span>
          弗洛里安·朗根沙伊特（Florian
          Langenscheidt）是德国出版商、畅销书作家、演说家和风险投资家，为Capital、Forbes 和Max杂志撰写了大量专栏，获得众多消费者的欢迎与追捧。于他而言，
          <b
            >品牌就是一种承诺，是对卓越性能和完美细节的承诺，是对品质和传承的承诺，“这些承诺吸引我们，让我们选择最好的、最漂亮的、最优雅的产品。”</b
          >
          <br /><br />
          <span style="color: #2963a4; font-weight: 600; font-size: 20px">
            Tetra德彩同时获得“年度品牌奖”
          </span>
          <br />
          来自世界各地的超过11.5万名 宠物主人将Tetra德彩票选为他们最喜欢的鱼饲料品牌。
          世界品牌论坛授予Tetra德彩“世纪品牌”
          （宠物类别），以表彰Tetra德彩杰出的观赏鱼饲料产品!
        </span>
      </p>

      <div class="d-flex j-center" style="width: 1200px">
        <!-- 图片 -->
        <div style="width: 1100px; margin: 30px 0">
          <img
            src="../assets/article04.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>

      <p style="font-size: 20px; color: #333; line-height: 2em">
        世界品牌论坛主席Richard Rowles说:
        <strong
          >“ 'Animalis'
          版的奖项是对团队在不断发展的宠物和动物行业中建立和保持品牌存在的不懈努力的认可。”</strong
        >
      </p>

      <div class="d-flex j-center" style="width: 1200px">
        <!-- 图片 -->
        <div style="width: 1100px; margin: 30px 0">
          <img
            src="../assets/article05.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>

      <p style="font-size: 20px; color: #333; line-height: 2em">
        弗洛里安·朗根沙伊特（Florian Tetra德彩品牌拥有独特的产品，
        例如举世闻名的TetraMin鱼饲料——其独特的黄色罐子和棕色盖子——是卓越养鱼的完美典范。
        <br /><br />
        <span style="color: #2963a4; font-weight: 600; font-size: 20px">
          Tetra德彩当之无愧的“最高质量奖”
        </span>
        <br />
        Tetra德国总部水族营销负责人说:“我们正在不断地系统地开发新产品，并根据消费者研究改进现有产品。”
        Tetra德彩在德国FAZ管理、市场和媒体信息研究所的分析中，以满分100分的成绩获得满分100分，并在游泳领域获得了享有盛誉的“最高品质奖”。
        在这项研究中，德国约22000家公司的社会倾听调查了这些公司的产品和服务、可及性、客户满意度、创新和质量。
      </p>

      <div class="d-flex j-center" style="width: 1200px">
        <!-- 图片 -->
        <div style="width: 1100px; margin: 30px 0">
          <img
            src="../assets/article06.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>

      <p style="font-size: 20px; color: #333; line-height: 2em">
        “最高质量奖”印证了Tetra德彩长期以来的品牌战略，并将激励它继续超越自己的标准，
        使养鱼更容易，最重要的是，对鱼类和其他水生动物更好。
        <br /><br />
        <span style="color: #2963a4; font-weight: 600; font-size: 20px">
          Tetra德彩获奖的背后
        </span>
        <br />
        Tetra德彩是全球水产行业的领导者，也是园林池塘产品的最大制造商之一。Tetra德彩由Ulrich
        Baensch博士于1951年创立。Ulrich
        Baensch博士是一位年轻的科学家，对观赏性养鱼有着巨大的热情和迷恋。1955年，他和他的团队发明了世界闻名的片状食品TetraMin——从此成为世界上最畅销的鱼类食品。
        在接下来的几十年里，Tetra德彩为水族馆、池塘和玻璃容器开发了更多的产品。
      </p>

      <div class="d-flex j-center" style="width: 1200px">
        <!-- 图片 -->
        <div style="width: 1100px; margin: 30px 0">
          <img
            src="../assets/article07.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>

      <p style="font-size: 20px; color: #333; line-height: 2em">
        直到今天，Ulrich
        Baensch博士革命性和创造性的激情一直牢牢地扎根在Tetra德彩的DNA中。Tetra德彩的成功源于独特的研发部门，也源于与客户建立的信任关系。Tetra德彩的原则是始终提供专家的建议和专业的帮助，创造独特和迷人的每一天的经验，这是我们成功的最重要的关键之一。
        Tetra德彩产品在全球约120个国家销售。自2005年以来，Tetra GmbH是Spectrum
        Brands Holdings, Inc.品谱集团的一部分。
      </p>

      <div class="d-flex j-center" style="width: 1200px">
        <!-- 图片 -->
        <div style="width: 1100px; margin: 30px 0">
          <img
            src="../assets/article08.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>

      <p style="font-size: 20px; color: #333; line-height: 2em;margin-bottom: 40px;">
        对于Tetra德彩来说，这些奖项既是对全面品牌战略的验证，也是对未来的激励。公司经过70年的潜心研究，不断开发创新产品。
        与此同时，Tetra德彩确切地知道消费者想要什么和需要什么，将二者结合仍然是品牌战略的核心。
      </p>
    </div>
    
  </div>

      <!-- 底部 -->
      <foot/>
      
 </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.container {
  width: 1200px;
  margin: 0 auto;
  .title {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 30px !important;
  }
}
</style>